import { useSelector } from 'react-redux';
import { useEventWritable } from '../../hooks/useEventWritable';

// Shown on every page while the selected event is closed (`enabled=false`).
// Without it a closed event looks exactly like an open one until the first
// write comes back as a 409, which reads as a bug rather than a policy.
function EventReadOnlyBanner() {
  const currentEvent = useSelector((state) => state.auth.currentEvent);
  const writable = useEventWritable();

  if (writable || !currentEvent) {
    return null;
  }

  return (
    <div
      className='alert alert-warning border-0 rounded-0 mb-0 py-2 text-center'
      role='alert'
    >
      <i className='fas fa-lock me-2' />
      <strong>{currentEvent.name}</strong> ist abgeschlossen — nur Lesezugriff.
      Änderungen sind für dieses Event nicht mehr möglich.
    </div>
  );
}

export default EventReadOnlyBanner;
